import { useContext } from "react";
import moment from "moment";
import "moment/locale/de";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useTranslation } from "react-i18next";
import { DataScienceContext } from "../context/DataScienceContext";
import { CalendarWeekIcon } from "@components/icons";

function DateFilter({ setDateType }) {
  const { t, i18n } = useTranslation();
  const { setStartDate, setEndDate, setInitialStartDate, setInitialEndDate, setActiveDate } =
    useContext(DataScienceContext);

  const currentLanguage = i18n.language || "en";

  // German locale configuration
  const localeConfig = {
    de: {
      format: "DD.MM.YYYY",
      separator: " - ",
      applyLabel: "Anwenden",
      cancelLabel: "Abbrechen",
      fromLabel: "Von",
      toLabel: "Bis",
      customRangeLabel: "Benutzerdefiniert",
      weekLabel: "W",
      daysOfWeek: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      monthNames: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
      firstDay: 1,
    },
    en: {
      format: "DD.MM.YYYY",
      separator: " - ",
      applyLabel: "Apply",
      cancelLabel: "Cancel",
      fromLabel: "From",
      toLabel: "To",
      customRangeLabel: "Custom",
      weekLabel: "W",
      daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      firstDay: 1,
    },
    it: {
      format: "DD.MM.YYYY",
      separator: " - ",
      applyLabel: "Applica",
      cancelLabel: "Annulla",
      fromLabel: "Da",
      toLabel: "A",
      customRangeLabel: "Personalizzato",
      weekLabel: "S",
      daysOfWeek: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      firstDay: 1,
    },
  };

  const handleEvent = (_, picker) => {
    const startDate = moment(picker.startDate).format("YYYY-MM-DD");
    const endDate = moment(picker.endDate).format("YYYY-MM-DD");
    setStartDate(startDate);
    setEndDate(endDate);
    setInitialStartDate(startDate);
    setInitialEndDate(endDate);
    setActiveDate(startDate + endDate);
    setDateType(5);
  };

  // Set moment locale based on current language
  moment.locale(currentLanguage);

  return (
    <DateRangePicker
      initialSettings={{
        timePicker: true,
        opens: "left",
        linkedCalendars: false,
        applyButtonClasses: "btn-primary",
        drops: "auto",
        startDate: moment().subtract(3, "weeks").format("DD MM YYYY"),
        endDate: moment().format("DD MM YYYY"),
        locale: localeConfig[currentLanguage] || localeConfig.en,
      }}
      onApply={handleEvent}
    >
      <button
        type="button"
        className="btn btn-sm w-100 d-flex align-items-center justify-content-center gap-2"
        style={{
          background: "transparent",
          border: "none",
          padding: "0.5rem",
          cursor: "pointer",
          fontSize: "0.875rem",
        }}
      >
        <CalendarWeekIcon />
        <span>{t("custom_range")}</span>
      </button>
    </DateRangePicker>
  );
}

export default DateFilter;
